import * as z from 'zod';

const c_code = z.string(); // .regex(/^\+?[1-9]\d{0,2}$/);

export function callingCodeSchema() {
  return z.string().refine((v) => c_code.safeParse(v).success, {
    error: 'Invalid Calling Code',
  });
}

export function phoneFormatSchema(optional = true) {
  return z.string().refine(
    (v) => {
      if (optional) {
        return v?.trim() === '' ? true : !!v;
      }
      return !v;
    },
    {
      error: 'Invalid Phone Format',
    }
  );
}
